var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useState } from "react";
import get from "lodash/get";
import set from "lodash/set";
import pick from "lodash/pick";
import pickBy from "lodash/pickBy";
import merge from "lodash/merge";
import has from "lodash/has";
import omit from "lodash/omit";
import size from "lodash/size";
import assign from "lodash/assign";
import isEqual from "lodash/isEqual";
import { connect } from '../../store/connect';
import { getBookDataPaginated, getBookDataPaginatedResponse, getBookEntities, getCustomerData, getCustomerListData, getInitialData, setRequestQueryString } from "../../store/actions/response.actions";
import { bookNow, updateCart, updateForm, setPaybookReferencePage, submitBookingForm, CHECKOUT_CONTEXT_ENUM, resetBookData } from "../../store/actions";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { NoDataToDisplay } from "../NoDataToDisplay/NoDataToDisplay";
import { CourseTimespanModel, getBookManager } from "../../models/BookModel";
import { ReactiveForm } from '../Form';
import { componentMapper, validatorMapper } from "../Form/form-constants";
import { getCartItemIds, getNormalizedCartItems, useBookNowListener, useCartListener } from "../Cart/cart.helpers";
import { useBookingFormSchema } from "../BookingForm/schema";
import { useTranslation } from "react-i18next";
import { BookingCartDescription } from "../BookingForm/BookingCartDescription";
import { getClassName, useMediaQuery } from "../../helpers";
import { ADMIN_BOOKING_FORM_SETTINGS, BUTTON_FORM_SUBMIT, CART, PARTICIPANT_GROUP, PARTICIPANT_GROUP_FLAT } from "../../classConstants";
import { getFieldPaths, CART_ITEMS_PATH, hasAllowAllEvents, normalizeDefaultFormData, deriveValidationMessages, hasWaitlistBookings } from "../BookingForm/booking-form.helpers";
import styled from "styled-components";
import { ERoute } from "../../helpers/Routes";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { Loader } from "../Loader/Loader";
import { PriceBreakup } from "../PriceBreakup/PriceBreakup";
import { isAdminIntegration } from "../../store/statePresenter";
import qs from "querystring";
import { useConfig } from "../../AppContext";
import { getBookingFormManager } from "../../FormManager/BookingFormManager";
import { setParticipantForm } from "../../store/store-helpers";
import { getIntegrationName } from "../../store/stateGetter";
import { useLocation } from "react-router";
import { getBookDataResponseManager } from "../../models/BookModel/helpers";
var checkoutFactory = function () {
    var emptyArray = [];
    var emptyObject = {};
    var Checkout = function (props) {
        var t = useTranslation().t;
        var isOneSided = useConfig("oneSidedForm", props.isOneSided)[0];
        var onBack = useConfig("checkout.onBack")[0];
        var campaignName = useConfig("campaignName")[0];
        var bookingId = new URLSearchParams(useLocation().search).get("bookingId");
        var showPriceBreakup = useConfig("showPriceBreakup", true)[0];
        var _a = useState(false), isLastTab = _a[0], setIsLastTab = _a[1];
        var isMobile = useMediaQuery('(max-width: 786px)');
        var initialValues = useMemo(function () { return props.mergedForm; }, [JSON.stringify(props.mergedForm)]);
        var cartItems = get(props, "cartItems") || get(initialValues, "booking_data.cart_items", []);
        var bookingFormSchema = useBookingFormSchema(props.name, [], {
            showEventForm: false,
            showCourseMeta: false
        });
        var handleSubmit = function (formValues) {
            var _a, _b, _c;
            if (!isLastTab) {
                return;
            }
            setParticipantForm((_a = get(props, "formManager")) === null || _a === void 0 ? void 0 : _a.state);
            (_b = get(props, "formManager")) === null || _b === void 0 ? void 0 : _b.setCampaignName(campaignName);
            var request = (_c = get(props, "formManager")) === null || _c === void 0 ? void 0 : _c.toRequestBody(props.topFormFieldPaths);
            props.submitBookingForm(request, ERoute.CHECKOUT);
        };
        var ftimespans = props.timespanIds.join(",");
        var queryString = qs.stringify(pickBy({
            page: 1,
            bookingId: bookingId,
            ftimespans: ftimespans,
            waitlist_bookings: props.isAdminIntegration && hasWaitlistBookings(initialValues),
            allow_all_events: props.isAdminIntegration && hasAllowAllEvents(initialValues),
        }, function (value) { return !!value; }));
        useEffect(function () { return function () {
            props.setRequestQueryString(API_METHODS_ENUM.GET_BOOK_ENTITIES, null, 1);
        }; }, []);
        // Reset Page number to 1.
        useEffect(function () {
            return function () {
                props.resetBookData(true);
            };
        }, [props.resetBookData]);
        // Load All Events.
        // Needed to list cart items.
        useEffect(function () {
            var _a;
            if (!ftimespans)
                return;
            (_a = get(props, "burstCache")) === null || _a === void 0 ? void 0 : _a();
            props.getBookEntities(queryString);
            props.setRequestQueryString(API_METHODS_ENUM.GET_BOOK_ENTITIES, queryString, 1);
        }, [ftimespans, queryString]);
        // Add Cart event listener to update cart with new items
        useCartListener(function (cart) {
            if (!initialValues)
                return;
            props.updateForm({
                name: props.name,
                form: merge({}, initialValues, { cart: cart })
            }, "checkout cartlisterner");
        }, { noEmit: true });
        // Add Cart event listener to update cart with new items
        useBookNowListener(function (form) {
            if (!initialValues)
                return;
            props.updateForm({
                name: props.name,
                form: set(initialValues, CART_ITEMS_PATH, get(form, CART_ITEMS_PATH))
            }, "checkout booknowlistener");
        });
        // Update cart to persistentState
        var cartItemsWithoutParticipantIndices = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function (item) { return omit(item, "booking.personal_data_index"); })) || [];
        // Update cart to persistentState
        useEffect(function () {
            if (!props.isCartContext) {
                props.updateForm({
                    name: props.name,
                    form: set(initialValues, CART_ITEMS_PATH, cartItems)
                }, "updatecartitems");
                // bookNow(cartItems);
                return;
            }
            ;
            props.updateCart(cartItemsWithoutParticipantIndices);
        }, [props.isCartContext, JSON.stringify(cartItemsWithoutParticipantIndices)]);
        var validationErrors = React.useMemo(function () { return deriveValidationMessages(get(props, "formManager"), props.validationErrors, props.topFormFieldPaths, props.otherStages); }, [props.validationErrors, initialValues, props.topFormFieldPaths, props.otherStages]);
        if (props.hasErrored)
            return null;
        if (ftimespans && (props.otherStages.length === 0 || props.isLoading))
            return React.createElement(Loader, null);
        if (!ftimespans || !props.cartItemsCount)
            return React.createElement(NoDataToDisplay, null);
        var renderPriceBreakup = function () {
            if (!showPriceBreakup)
                return null;
            if (props.hidePriceBreakup)
                return null;
            return React.createElement(PriceBreakup, { name: props.name });
        };
        var renderRightSideSection = function () {
            return (React.createElement(React.Fragment, null,
                !isMobile && renderPriceBreakup(),
                React.createElement(BookingCartDescription, null)));
        };
        var schema = bookingFormSchema.getWizSchema({ eventForm: [], otherSteps: props.otherStages }, {
            onNextWizardState: function (currentStep, isLast) {
                setIsLastTab(isLast);
            },
            backLabel: t("bookcart.back"),
            onBack: onBack,
            submitIcon: isLastTab && props.buttonsWithIcon ? "check" : null,
            submitLabel: isLastTab ? t(props.submitButtonLabel) : t("bookcart.next_step"),
            invalidStepIndex: props.invalidStepIndex,
            leftSideOnly: isOneSided,
            rightSideSection: renderRightSideSection(),
            leftSideSection: (isOneSided || isMobile) && renderPriceBreakup(),
            className: getClassName(props.className, CART),
        }, validationErrors).schema;
        return (React.createElement(ReactiveForm, { name: props.name, schema: schema, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: initialValues, onSubmit: handleSubmit }));
    };
    var mapStateToProps = function (state, ownProps) {
        var _a, _b;
        var adminIntegration = isAdminIntegration(state);
        var name = get(state.globalReducer, "checkoutContext", CHECKOUT_CONTEXT_ENUM.CART);
        var isCartContext = name === CHECKOUT_CONTEXT_ENUM.CART;
        var pagedBookData = getBookDataPaginated(state.responseReducer);
        return {
            name: name,
            isCartContext: isCartContext,
            integrationName: getIntegrationName(state),
            customerId: get(ownProps, "customerId"),
            isAdminIntegration: adminIntegration,
            additionalProps: get(state, "courseReducer.additionalProps", emptyObject),
            form: get(state, "formReducer.forms." + name),
            adminSettings: get(state, "formReducer.forms.adminsettings"),
            checkoutForm: get(state, "globalReducer.form"),
            cartItems: isCartContext ? get(state, "cartReducer.cart_items", emptyArray) : emptyArray,
            validationErrors: get(state, "appReducer.validationErrors", null),
            savedParticipantForm: get(state, "appReducer.savedParticipantForm", null),
            initialData: get(getInitialData(state.responseReducer), "response"),
            entities: getBookDataPaginatedResponse(state.responseReducer),
            requestQueryString: get(getBookDataPaginated(state.responseReducer), "0.requestQueryString", null),
            completedQueryString: get(getBookDataPaginated(state.responseReducer), "0.queryString", null),
            loaderState: state.loaderReducer,
            customerList: ((_a = getCustomerListData(get(state, "responseReducer"))) === null || _a === void 0 ? void 0 : _a.response) || null,
            customerData: ((_b = getCustomerData(get(state, "responseReducer"))) === null || _b === void 0 ? void 0 : _b.response) || null,
        };
    };
    var mergeProps = function (state, dispatch, props) {
        var _a;
        var _b, _c, _d, _e;
        var initialDataRm = state.initialData && getResponseManager(state.initialData);
        var options = initialDataRm === null || initialDataRm === void 0 ? void 0 : initialDataRm.options();
        var optionEntities = initialDataRm === null || initialDataRm === void 0 ? void 0 : initialDataRm.entities();
        var rm = state.entities ? getBookDataResponseManager(state.entities) : undefined;
        var entities = rm === null || rm === void 0 ? void 0 : rm.entities;
        var waitListEntities = (rm === null || rm === void 0 ? void 0 : rm.waitlist_entities) || {};
        var defaultFormData = rm === null || rm === void 0 ? void 0 : rm.form_data;
        var loaderState = new LoaderState(state.loaderState, { keys: [API_METHODS_ENUM.GET_BOOK_ENTITIES, API_METHODS_ENUM.GET_INITIAL_ENTITIES] });
        var cartItems = ((state.isCartContext ? state.cartItems : (_c = (_b = state.checkoutForm) === null || _b === void 0 ? void 0 : _b.booking_data) === null || _c === void 0 ? void 0 : _c.cart_items) || []).filter(Boolean);
        var cart = getNormalizedCartItems(cartItems);
        var additionalProps = state.additionalProps;
        var timespanIds = getCartItemIds(cart);
        var ownOptions = get(props, "formOptions", {});
        var showCustomerSearchAndSelect = get(props, "showCustomerSearchAndSelect", false);
        var showParticipantSearchAndSelect = get(props, "showParticipantSearchAndSelect", false);
        var adminSettings = state.adminSettings || {};
        var customerId = state.customerId || "";
        var oldCustomerId = ((_d = state.form) === null || _d === void 0 ? void 0 : _d.customerId) || "";
        var form = merge({}, { booking_data: { cart_items: cart } }, state.form, { customerId: state.customerId }, adminSettings);
        var mergedProps = __assign(__assign(__assign({}, dispatch), props), { timespanIds: timespanIds, name: state.name, validationErrors: state.validationErrors, mergedForm: form, otherStages: [], topFormFieldPaths: [], isOneSided: true, cartItems: state.isCartContext ? undefined : cartItems, isCartContext: state.isCartContext, cartItemsCount: (cart === null || cart === void 0 ? void 0 : cart.length) || 0, submitButtonLabel: "", hasErrored: loaderState.hasErrored(), isLoading: !entities || loaderState.isLoading() || !loaderState.hasLoaded(), isAdminIntegration: state.isAdminIntegration, invalidStepIndex: null, burstCache: CourseTimespanModel.burstCache });
        // if (customerId && !get(state, `customerData.body.${customerId}`)) {
        //     unset(mergedProps.mergedForm, `form_data`)
        // }
        if ((entities === null || entities === void 0 ? void 0 : entities.form_items) && (!customerId || get(state, "customerData.body." + customerId))) {
            var bmOptions = __assign(__assign(__assign({}, options), ownOptions), { customerId: customerId,
                waitListEntities: waitListEntities,
                defaultFormData: defaultFormData,
                showCustomerSearchAndSelect: showCustomerSearchAndSelect,
                showParticipantSearchAndSelect: showParticipantSearchAndSelect, displayTimespanTitleInParticipants: true, showParticipantDropdown: true, showAvailableTimespansOnly: true, integrationName: state.integrationName, customerList: get(state, "customerList.body", []), customerData: get(state, "customerData.body", {}), isLoadingCustomers: new LoaderState(state.loaderState, { keys: [API_METHODS_ENUM.GET_CUSTOMER_LIST] }).isLoading(), no_accordion: additionalProps.no_accordion, accordion_all_open: additionalProps.accordion_all_open, savedParticipantForm: state.savedParticipantForm, showSaveParticipants: props.showSaveParticipants, isAdminIntegration: state.isAdminIntegration, disableAvailabilityCheck: state.isAdminIntegration && hasAllowAllEvents(state.adminSettings), collapseValidParticipantsByDefault: props.collapseValidParticipantsByDefault, hide_all_participant_forms: additionalProps.hide_all_participant_forms, adminSettings: adminSettings, takeDirtyIndices: true, takeBookingId: !state.isAdminIntegration, nonBindingWaitlistIsBookedOut: state.isCartContext });
            var bm = getBookManager(__assign(__assign({}, entities), optionEntities), bmOptions);
            if (!state.requestQueryString || state.requestQueryString !== state.completedQueryString) {
                return mergedProps;
            }
            var validationErrors = state.validationErrors;
            var mergedForm = mergedProps.mergedForm;
            if (!state.isCartContext && !has(mergedForm, "booking_data")) {
                assign(mergedForm, pick(cart[0], "booking_data"));
            }
            if (!((_e = defaultFormData === null || defaultFormData === void 0 ? void 0 : defaultFormData.booking_data) === null || _e === void 0 ? void 0 : _e.booking_id) && (oldCustomerId !== customerId || !form.form_data || size(form.form_data) === 0)) {
                mergedForm = merge({}, { form_data: get(state, "customerData.body." + customerId + ".form_data", {}) }, omit(mergedForm, "form_data"), { customerId: customerId });
            }
            var formManager = getBookingFormManager({
                modelManager: bm,
                form: normalizeDefaultFormData(mergedForm),
            }, bmOptions);
            var formState = mergedForm = formManager.state;
            mergedProps.formManager = formManager;
            mergedProps.isOneSided = props.isOneSided || !!(options === null || options === void 0 ? void 0 : options.is_booking_form_one_sided);
            (_a = mergedProps.otherStages).push.apply(_a, bm.getFormSteps(formState, validationErrors));
            mergedProps.topFormFieldPaths = getFieldPaths(mergedProps.otherStages, mergedProps);
            mergedProps.mergedForm = formManager.toJSON(formState.getFormDefaultValues());
            mergedProps.submitButtonLabel = bm.getSubmitButtonLabel(formState, options);
            var isSubmitting = new LoaderState(loaderState, { keys: [API_METHODS_ENUM.POST_BOOKING_FORM] }).isLoading();
            if (isSubmitting) {
                mergedProps.invalidStepIndex = null;
            }
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { resetBookData: resetBookData, setPaybookReferencePage: setPaybookReferencePage, setRequestQueryString: setRequestQueryString, submitBookingForm: submitBookingForm, getBookEntities: getBookEntities, updateCart: updateCart, bookNow: bookNow, updateForm: updateForm }, mergeProps, { areMergedPropsEqual: isEqual, areStatePropsEqual: isEqual })(Checkout);
};
export var Checkout = styled(checkoutFactory())(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n        flex: 1\n    }\n\n    .", ",\n    .", "{\n        border-top: 1px solid #ccc !important;\n        padding-top: var(--ws-input-margin) !important;\n        &:not(:first-of-type) {\n            margin-top: calc(var(--ws-input-margin) * 2) !important;\n        }\n        \n        legend {\n            max-width: 80%;\n            padding-right: var(--ws-input-margin) !important;\n            h3 { margin: 0; }\n        }\n    }\n    .", " legend h3 {\n        margin-bottom: 0.5em;\n    }\n"], ["\n    .", " {\n        flex: 1\n    }\n\n    .", ",\n    .", "{\n        border-top: 1px solid #ccc !important;\n        padding-top: var(--ws-input-margin) !important;\n        &:not(:first-of-type) {\n            margin-top: calc(var(--ws-input-margin) * 2) !important;\n        }\n        \n        legend {\n            max-width: 80%;\n            padding-right: var(--ws-input-margin) !important;\n            h3 { margin: 0; }\n        }\n    }\n    .", " legend h3 {\n        margin-bottom: 0.5em;\n    }\n"])), BUTTON_FORM_SUBMIT, PARTICIPANT_GROUP, ADMIN_BOOKING_FORM_SETTINGS, PARTICIPANT_GROUP_FLAT);
var templateObject_1;
